import {
  useSearchParams,
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import "../NewHome/HomePage.scss";
import emailjs from "@emailjs/browser";
import { useRef } from "react";
import PopupGfg from "./ContactPagePopUp";

export default function ContactPage() {
  const { t } = useTranslation(["page"]);
  const [searchParams, setSearchParams] = useSearchParams();
  const ver = searchParams.get("ver") || "1";
  const lang = searchParams.get("lang");

  //   if (lang) {
  //     i18n.changeLanguage(lang);
  //   }

  // Send email to support@apeirocorp.com
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_haezzp5",
        "template_jqjm6qn",
        form.current,
        "kzzWFh_ogF7PBPvl0"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="page-content ContactPage">
      <div className="section-content">
        <div className="TitleSection">
          <div className="section-title">{t(`v${ver}.ContactPage.title`)}</div>
          <div className="section-subtitle">
            {t(`v${ver}.ContactPage.subtitle`)}
          </div>
        </div>
        <div className="FormSection">
          <form ref={form} onSubmit={sendEmail}>
            <div className="form-container-background">
              <div className="flex-column">
                <div className="flex-responsive">
                  <div className="form-left-container flex-column">
                    <div className="form-name">
                      Name: <br />
                      <input
                        className="name-container form-container"
                        type="text"
                        name="user_name"
                      ></input>
                      <br />
                    </div>
                    <div className="form-email">
                      Email: <br />
                      <input
                        className="email-container form-container"
                        type="text"
                        name="user_email"
                        required
                      ></input>
                      <br />
                    </div>
                  </div>
                  <div className="form-right-container form-inquiry">
                    How can we help? <br />
                    <textarea
                      className="inquiry-container form-container"
                      type="text"
                      name="message"
                      required
                    ></textarea>
                    <br />
                  </div>
                </div>
              </div>
              <div className="form-submit">
                <input
                  className="submit-container form-container"
                  type="submit"
                  value="Submit"
                  required
                ></input>
              </div>
            </div>
          </form>
        </div>
        <PopupGfg />
      </div>
    </div>
  );
}
